import Glide from '@glidejs/glide';

new Glide('#slider', {
  type: 'slider',
  perView: 1,
  dragDistance: true,
  dragThreshold: true,
}).mount();